import { createQueryClient } from "@msuite/picasso";

const queryClient = createQueryClient();

export { queryClient };
